<script>
import table from './api-keys.table.js'
import getExportedFilename from '@lib/utils/get-exported-filename'
import { mapGetters } from 'vuex'

export default {
  name: 'ApiKeys',
  data() {
    return {
      table: table(this),
    }
  },
  methods: {
    ...mapGetters('me', [
      'canCreateApiKey',
    ]),
    handleClick() {
      this.$router.push({
        name: 'api-key-create',
      })
    },
    onRowClick(row) {
      this.$router.push({
        name: 'api-key',
        params: {
          id: row.id,
        },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="API Keys">
    <template slot="header">
      <el-button
        v-if="canCreateApiKey"
        type="primary"
        icon="el-icon-plus"
        plain
        @click="handleClick"
      >
        Add New API Key
      </el-button>
    </template>
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      :export-filename="getExportedFilename"
      @row-click="onRowClick"
    />
  </main-layout>
</template>
